import { pricingRooms } from './proposal-scope.js';
/** Freeze the commercial selection into customer geometry; never mutate assessment finishes. */
export function customerScopePlan(doc, pricing) {
    const products = pricing.lines.filter(l => l.kind === 'product');
    const selections = products.map(l => doc.pricing?.products.find(s => s.id === l.selection_id && s.role !== 'option'));
    // Historical/unbound copies keep their existing finish-based scope. Never guess a room from quantity.
    if (!selections.length || selections.some(s => !s || !(s.scope_ids?.length || s.rooms.length)))
        return doc.assessment.plan;
    const scopes = pricingRooms(doc);
    const selected = new Set();
    for (const selection of selections) {
        const s = selection;
        const matches = scopes.filter(scope => s.scope_ids?.length ? s.scope_ids.includes(scope.id) : s.rooms.includes(scope.name));
        const expected = s.scope_ids?.length || s.rooms.length;
        if (matches.length !== expected)
            return doc.assessment.plan;
        for (const scope of matches)
            selected.add(scope.id);
    }
    const roomIds = new Set(doc.assessment.rooms.filter(room => !room.out_of_scope && !room.is_void &&
        pricingRooms({ ...doc, assessment: { ...doc.assessment, rooms: [room] } }).some(scope => selected.has(scope.id))).map(r => r.id));
    return doc.assessment.plan.map(f => ({ ...f, rooms: f.rooms.map(r => ({ ...r, in_proposal: roomIds.has(r.id) && !r.out_of_scope && !r.is_void })) }));
}
//# sourceMappingURL=customer-scope-plan.js.map